import { LevelMonitorContent } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/LevelMonitorContent';
import { WeatherStationContent } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/WeatherStationContent';
import { PersonalLocatorBeaconContent } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/PersonalLocatorBeaconContent';
import { useContext } from 'react';
import { DeviceDetailContext } from 'app/agriculture/routes/Devices/DeviceDetails/context/DeviceDetailContextProvider';
import { DeviceSparkChartContent } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/DeviceSparkChart/DeviceSparkChartContent';
import { TrailCamContent } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/trailcam/TrailCamContent';
import { SuspenseWrapper } from 'app/agriculture/components/SuspenseWrapper/SuspenseWrapper';
import { WeatherStationContentSkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/WeatherStationContentSkeleton';
import { LevelMonitorContentSkeleton } from 'app/agriculture/routes/Devices/DeviceDetails/components/content/LevelMonitorContentSkeleton';

export function DeviceDetailsContent() {
    const { device } = useContext(DeviceDetailContext);
    const { deviceType } = device;
    switch (deviceType) {
        case 'Weather Station':
            return (
                <SuspenseWrapper loadingComponent={<WeatherStationContentSkeleton />}>
                    <WeatherStationContent />
                </SuspenseWrapper>
            );
        case 'Personal Locator Beacon':
            return <PersonalLocatorBeaconContent />;
        case 'Yarn Gateway':
            return <DeviceSparkChartContent />;
        case 'Yarn Relay':
            return <DeviceSparkChartContent />;
        case 'Trail Cam':
            return <TrailCamContent />;
        case 'Level Monitor':
            return (
                <SuspenseWrapper loadingComponent={<LevelMonitorContentSkeleton />}>
                    <LevelMonitorContent />
                </SuspenseWrapper>
            );
        default:
            return null;
    }
}
